import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { PublicAccount } from '@trnsact/trnsact-shared-types';
import AddIcon from '@mui/icons-material/Add';
import { ContactsTable } from '../../tables';
import { UserProfile } from 'types';
import { Button } from '@mui/material';
import DealerContactModal from 'pages/LenderPortal/DealerMgmt/DealerContactModal';
import { useState } from 'react';

interface Props {
  dealerAccount: PublicAccount;
  refetchDealerAccount: () => void;
}

export const ContactsCard = ({ dealerAccount, refetchDealerAccount }: Props) => {
  const [isAddContactMopenModal, setIsAddContactMopenModal] = useState(false);

  return (
    <>
      <CardContainer
        title="Contacts"
        actionBtn={
          <Button
            variant="contained"
            size="small"
            startIcon={<AddIcon />}
            onClick={() => setIsAddContactMopenModal(true)}
          >
            Add Contact
          </Button>
        }
      >
        <ContactsTable tableData={dealerAccount?.contacts as UserProfile[]} />
      </CardContainer>

      <DealerContactModal
        open={isAddContactMopenModal}
        accountId={dealerAccount?.id}
        dynamicsAccountId={dealerAccount?.dynamicsAccountId}
        handleClose={() => setIsAddContactMopenModal(false)}
        refetchContacts={() => refetchDealerAccount()}
        contact={null}
        create={true}
        disableEdit={true}
        lenderProfileId={null}
        isDealerInviteFromLender={false}
      />
    </>
  );
};
